import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const AziendaAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		azi_denominazione: yup.string().required().label("Azi Denominazione"),
		azi_email: yup.string().email().required().label("Azi Email"),
		azi_password: yup.string().required().label("Azi Password"),
		confirm_password: yup.string().required().label("Confirm Password").oneOf([yup.ref('azi_password')], "Your passwords do not match"),
		azi_telefono: yup.string().nullable().label("Azi Telefono")
	});
	
	//form default values
	const formDefaultValues = {
		azi_denominazione: '', 
		azi_email: '', 
		azi_password: '', 
		confirm_password: '', 
		azi_telefono: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/azienda`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="AziendaAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Aggiungere nuova"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Azi Denominazione *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <CheckDuplicate value={formik.values.azi_denominazione} apiPath="components_data/azienda_azi_denominazione_exist">
                                                { (checker) => 
                                                <>
                                                <InputText name="azi_denominazione" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.azi_denominazione}   label="Azi Denominazione" type="text" placeholder="accedere Azi Denominazione"        className={inputClassName(formik?.errors?.azi_denominazione)} />
                                                <ErrorMessage name="azi_denominazione" component="span" className="p-error" />
                                                {(!checker.loading && checker.exist) && <small className="p-error">Non disponibile</small>}
                                                {checker.loading && <small className="text-500">Checking...</small> }
                                                </>
                                                }
                                                </CheckDuplicate>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Azi Email *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <CheckDuplicate value={formik.values.azi_email} apiPath="components_data/azienda_azi_email_exist">
                                                { (checker) => 
                                                <>
                                                <InputText name="azi_email" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.azi_email}   label="Azi Email" type="email" placeholder="accedere Azi Email"        className={inputClassName(formik?.errors?.azi_email)} />
                                                <ErrorMessage name="azi_email" component="span" className="p-error" />
                                                {(!checker.loading && checker.exist) && <small className="p-error">Non disponibile</small>}
                                                {checker.loading && <small className="text-500">Checking...</small> }
                                                </>
                                                }
                                                </CheckDuplicate>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Azi Password *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Password name="azi_password" value={formik.values.azi_password} onChange={formik.handleChange} label="Azi Password" placeholder="accedere Azi Password"  inputClassName="w-full" toggleMask feedback className={inputClassName(formik?.errors?.azi_password)} />
                                                <ErrorMessage name="azi_password" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Confirm Password *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Password name="confirm_password" id="confirm_password" className={inputClassName(formik?.errors?.comfirm_password)} inputClassName="w-full" feedback={false} toggleMask  value={formik.values.confirm_password} onChange={formik.handleChange} label="conferma password" placeholder="conferma password"  />
                                                <ErrorMessage name="confirm_password" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Azi Telefono 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="azi_telefono"  onChange={formik.handleChange}  value={formik.values.azi_telefono}   label="Azi Telefono" type="text" placeholder="accedere Azi Telefono"        className={inputClassName(formik?.errors?.azi_telefono)} />
                                                <ErrorMessage name="azi_telefono" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Invia" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
AziendaAddPage.defaultProps = {
	primaryKey: 'azi_id',
	pageName: 'azienda',
	apiPath: 'azienda/add',
	routeName: 'aziendaadd',
	submitButtonLabel: "Invia",
	formValidationError: "Il modulo non è valido",
	formValidationMsg: "Si prega di compilare il modulo",
	msgTitle: "Crea registro",
	msgAfterSave: "Record aggiunto con successo",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AziendaAddPage;
